import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { faLocation, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { BREAKPOINTS } from '../../utils/consts';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type FooterContactCardProps = {	
    faIcon: IconDefinition,
    header: string,
    text: string,
}

function FooterContactCard({faIcon, header, text}: FooterContactCardProps) {
    return (
            <CardWrapperStyle>
                <IconTextStyle>
                    <FontAwesomeIcon icon={faIcon} />
                    <div>
                        <h3>{header}</h3>
                        <br/>
                        <p>{text} </p>
                    </div>
                </IconTextStyle>
            </CardWrapperStyle>    
            )
}

const CardWrapperStyle = styled.div`
        width: min(300px, 100%);
    margin: 20px;

        @media (max-width: ${BREAKPOINTS.MOBILE}) {
            margin: 10px 0;
        }
`

const IconTextStyle = styled.div`
    display: flex;
    gap: 20px;
`

export default FooterContactCard;